module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_vm._v("INVITATION TO A VOYAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec01"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("OLAUS MAGNUS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec02"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("OLAUS MAGNUS’S")]), _vm._v(" CARTA MARINA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec03"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("SEBASTIAN MÜNSTER’S")]), _vm._v(" MONSTRA MARINA & TERRESTRIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec04"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("ABRAHAM ORTELIUS’S")]), _vm._v(" ISLANDIA")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec05"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("MYTHICAL ANCESTRY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec06"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("NATURAL HISTORY INHERITANCE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_vm._v("THE VOYAGE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE VAST OCEAN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE ROCKAS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE SEA WORM")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE DUCK TREE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE POLYPUS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("BALENA & ORCA")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE SEA SWINE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE SEA UNICORN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE PRISTER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE ZIPHIUS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE SEA COW")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("A SEA RHINOCEROS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("SPERMACETI")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("A BEACHED WHALE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("MORE PRISTERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE ISLAND WHALE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE SEA SERPENT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("CARIBDIS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("ANOTHER PRISTER")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("A SEA CREATURE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("A ROSMARUS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("THE KRAKEN")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("LANDFALL")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0006-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0007-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0007-01.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_vm._v("APPENDICES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices#sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_vm._v("CARTA MARINA "), _c('i', [_vm._v("FULL KEY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices#sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("GLOSSARY OF SEA MONSTER COUNTERPARTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices#sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("TIME LINE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices#sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("RESOURCES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices#sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("INDEX")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/appendices#sec06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bck"
  }, [_c('i', [_vm._v("ACKNOWLEDGMENTS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "f0003-01"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0007-02.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0